<template>
  <div>
    <fieldset>
      <legend>Type of Relationship with Issuer</legend>
      <label class="control-label">My entity is</label>
      <div class="radio radio-primary" v-for="option in entityOptions">
        <input type="radio" id="ffba_entity" name="ffba_entity" :value="option.name" v-model="picked">
        <label class="control-label">{{ option.value }}</label>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  props : {
    defaults: Object
  },
  data() {
    return {
       entityOptions : [
         {
           name: 'majority_owned',
           value: 'an entity in which the majority of the voting securities are owned by, or a majority of the directors are, (1) officers, control persons, directors of the issuer,' +
               ' or (2) family members, close personal friends, or close business associates of officers, control persons, directors of the Issuer'
         },
         {
           name: 'trust',
           value: 'a trust or estate of which all of the beneficiaries or a majority of the trustees or executors officers are officers, control persons, directors of the Issuer, or (2)' +
                  ' family members, close personal friends or close business associates of officers, control persons, directors of the Issuer'
         }
       ],
      picked: null
    }
  },
  methods: {
    defaultValue() {
      if(this.defaults.ffba_entity === 'majority_owned') {
        this.picked = 'majority_owned'
      }
      if(this.defaults.ffba_entity === 'trust') {
        this.picked = 'trust'
      }
    }
  },
  created() {
    this.defaultValue()
  }
}
</script>